function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZaznamy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.01 150.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 26.13,
    width: 81.83,
    height: 121.45,
    rx: 3.7,
    ry: 3.7,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.14,2.59v26.76c0,1.68,1.43,3.03,3.19,3.03h28.24L94.14,2.59Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeLinejoin: "bevel",
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.07,3h-48.71c-1.76,0-3.19,1.43-3.19,3.19v19.94h37.47c1.76,0,3.19,1.43,3.19,3.19v95.13h37.99c1.76,0,3.19-1.43,3.19-3.19V32.83L96.07,3Z",
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.5,
    y: 39.91,
    width: 25.55,
    height: 34.17,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.05,
    y1: 93.32,
    x2: 75.36,
    y2: 93.32,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.05,
    y1: 109.83,
    x2: 75.36,
    y2: 109.83,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.05,
    y1: 126.34,
    x2: 75.36,
    y2: 126.34,
    style: {
      fill: "none",
      stroke: "#051f1f",
      strokeMiterlimit: 10,
      strokeWidth: 6
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZaznamy);
export default __webpack_public_path__ + "static/media/zaznamy.5d80ac2c92c06c9642801ff4eb4444a8.svg";
export { ForwardRef as ReactComponent };